// extracted by mini-css-extract-plugin
module.exports = {"formatMedia":"Item_formatMedia__1cT_l","formatImage":"Item_formatImage__14pbD"};